export const AUTH_USER   = 'AUTH_USER';
export const UNAUTH_USER = 'UNAUTH_USER';

export const UPDATE_MAP_PLACE = 'UPDATE_MAP_PLACE';
export const CLEAN_MAP_PLACE  = 'CLEAN_MAP_PLACE';